import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useOrdersState } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/context/orders-context';
import {
  isConfirmedOrder,
  sortChileOrderRows,
  sortStandardOrderRows,
} from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/utils/order-utils';

/** Active orders and open slots (minus slots already covered by a forecast), sorted and filtered for the orders list. */
export const useOrderRows = (filters: string[], isChileMarket = false) => {
  const {
    orderAssortmentQuery: { data: orderAssortment, isLoading },
    recommendationAssortmentQuery: { data: recommendationAssortment },
  } = useOrdersState();

  const activeOrdersAndOpenSlots = useMemo(() => {
    if (!orderAssortment) return [];

    const { activeOrders = [], openSlots = [] } = orderAssortment; // assign default values if the lists are undefined

    const filteredSlots =
      !recommendationAssortment || recommendationAssortment.recommendations?.length === 0
        ? openSlots
        : openSlots.filter(
            (slot) =>
              !recommendationAssortment.recommendations?.some((recommendation) =>
                dayjs(recommendation.dispatch).isSame(slot.dispatchDate, 'day')
              )
          );

    const combined = [...activeOrders, ...filteredSlots];

    return isChileMarket ? sortChileOrderRows(combined) : sortStandardOrderRows(combined);
  }, [orderAssortment, recommendationAssortment, isChileMarket]);

  const rows = useMemo(() => {
    if (!filters.length) return activeOrdersAndOpenSlots;

    return activeOrdersAndOpenSlots.filter((row) => {
      if (filters.includes('confirmed')) {
        return isConfirmedOrder(row, isChileMarket);
      } else return false;
    });
  }, [activeOrdersAndOpenSlots, filters, isChileMarket]);

  return { rows, isLoading };
};
